module.exports = __webpack_public_path__ + "videos/3fe16abc05ae7bf8d6eb8e1ed7dde279.mp4";